import { Guarded, route$navigation } from ":setup/qrouter";
import { Route } from "@solidjs/router";
import { Show } from "solid-js";
import { grading$judging, Judging } from ":src/modules/grading";
import { DashboardLayout } from ":src/layouts";
import routes from "./routes";
import { checkUserToken, checkPlatformSettings } from "../SHARED/guards";
import { account$signout, Profile, account$profile } from ":src/modules/account";
import { FAQInquiry, help_portal$faq_inquiry } from ":src/modules/help-portal";
import { Loader1 } from ":src/components/loaders";

export default function Evaluator() {
  const baseRoute = routes.BASE;
  return (
    <Guarded
      setup={{
        baseRoute,
        guard: {
          steps: [checkUserToken, checkPlatformSettings],
        },
      }}
      components={{
        pageNotFound: () => <div>this is Evaluator page error, this page doesn't exist</div>,
        layout(props) {
          const { guard } = props;

          return (
            <Show when={!guard.loading()} fallback={<Loader1 subtitle="Judge" msg={guard.msg()} />}>
              <DashboardLayout
                sideNav={{
                  setup: {
                    baseRoute,
                  },
                  components: {
                    items: [
                      grading$judging.Anchors.Side,
                      //
                      () => route$navigation.Elements.Filler(),
                      () => route$navigation.Elements.Divider({ class: "bg#a" }),
                      //
                      help_portal$faq_inquiry.Anchors.Side,
                      account$profile.Anchors.Side,
                      account$signout.Anchors.Side,
                    ],
                  },
                }}
                children={props.children}
              />
            </Show>
          );
        },
      }}
    >
      <Route path={routes.judging} component={Judging} />
      <Route path={routes.faq_inquiry} component={FAQInquiry} />
      <Route path={[routes.profile, "/"]} component={Profile} />
    </Guarded>
  );
}
